import { userApi } from "../api/api"
import { accessGlobalUserState } from "../stores/user"
import { simpleGetter } from "./common"

export const checkUserData = async (callback?: () => void) => {
    const userState = accessGlobalUserState()
    const response = await simpleGetter(userApi.getSelf, {})

    if (response.item) {
        if (response.item.roles) {
            userState.setFirst('uniqUser', 'roles', response.item.roles)
        }
        //console.log(response.item.priorities, Boolean(response.item.priorities))
        // if (Boolean(response.item.priorities)) {
        //     accessGlobalUserState().setFirst('user', 'priorities', response.item.priorities)
        // }
        // if (Boolean(response.item.suborganizations)) {
        //     accessGlobalUserState().setFirst('user', 'suborganizations', response.item.suborganizations)
        // }
        // if (response.item.gender?.id) {
        //     accessGlobalUserState().setFirst('user', 'gender', response.item.gender)
        // }
        // if (!response.item.document_number) {
        //     if (typeof (callback) === "function") {
        //         callback()
        //     } else {
        //         miscState.set('fillDataModalOpen', true)
        //     }
        // }
    }
}